import { MenuItem as MuiMenuItem } from '@mui/material';

import type { MenuItemProps, MenuItemTypeMap } from '@mui/material';

export const MENU_ITEM_TEST_ID = 'menu-item';

export const MenuItem = <
  D extends React.ElementType = MenuItemTypeMap['defaultComponent'],
  P = {},
>({
  children,
  ...props
}: MenuItemProps<D, P>) => (
  <MuiMenuItem data-testid={MENU_ITEM_TEST_ID} {...props}>
    {children}
  </MuiMenuItem>
);
